import ScoringWizard from './ScoringWizard'
import ScoringMenuButton from './components/TrainingMenuButton'

export { ScoringWizard, ScoringMenuButton }
export default ScoringWizard
